import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { first, mergeMap } from "rxjs/operators";

import { AuthJwtService } from "@lantern/app/core/auth";

import { GlobalAuthApi } from "@local/app/core/api/global-auth";
import { User } from "@local/app/models";

@Injectable()
export class UserInfoResolver {
  constructor(
    private authJwt: AuthJwtService,
    private globalAuthApi: GlobalAuthApi
  ) {}

  resolve(): Observable<User> {
    return this.authJwt.globalJwtToken.pipe(
      first(),
      mergeMap((token) => {
        if (token == null) {
          throw new Error("Expected user to be logged in");
        }
        return this.globalAuthApi.getUserInfo(token);
      })
    );
  }
}
